<div class="donationdrive-modal-parent" style="top: 10px;">
  <div class="ui_modal donationdrive-modal" style="border-radius: 10px;">
    <a href="javascript:void(0)" class="ui_close" (click)="closeIcon()"></a>
    <div class="ui_modal_text" style="font-size: 16px;line-height: 1.5;margin-bottom: 5px !important;flex-direction: column;">
      <p style="font-family: 'montserratlight';align-self: start;">Dear Student/Parent,</p>
      <p style="font-family: 'montserratlight';align-self: start;">Kindly fill up the following information for <i style="text-decoration: underline;font-size: 110%;">{{getStudentFullName()}}</i> so our teachers and staff can be better prepared for your class.</p>
      
    </div>
    <div class="ui_modal_content" style="overflow: auto;">
      <div class="sh-grid-1"  >
        <div class="formbox" style="padding-top: 5px;padding-left: 10px;">
          <!--h3>More information</h3-->
          <form [formGroup]="studentinfoForm">
            <div class="form-style-outer">
              <div class="sh-grid-1" >
                <div class="mat-div" [class.is-active]="eduBackgroundFldInFocus==true" [class.is-completed]="eduBackgroundFocussed() || eduBackgroundFldInFocus==true">
                  <label class="mat-label"><strong>Education Background</strong></label>
                  <textarea class="mat-input" style="max-height: 100px;" (keyup)="auto_grow($event)" formControlName="eduBackground" (focus)="eduBackgroundFldInFocus=true" (blur)="eduBackgroundFldInFocus=false"></textarea>
                </div>
              </div>
              <!--div class="sh-grid-1">
                <div class="mat-div" [class.is-active]="ethnicBackgroundFldInFocus==true" [class.is-completed]="ethnicBackgroundFocussed() || ethnicBackgroundFldInFocus==true">
                  <label class="mat-label">Ethnic Background</label>
                  <textarea class="mat-input" style="max-height: 100px;" (keyup)="auto_grow($event)" formControlName="ethnicBackground" (focus)="ethnicBackgroundFldInFocus=true" (blur)="ethnicBackgroundFldInFocus=false"></textarea>
                </div>
              </div-->
              <div class="sh-grid-1">
                <div class="mat-div" [class.is-active]="learningGoalsObjFldInFocus==true" [class.is-completed]="learningGoalsObjFocussed() || learningGoalsObjFldInFocus==true">
                  <label class="mat-label"><strong>Learning Goals &amp; Objectives</strong></label>
                  <textarea class="mat-input" style="max-height: 100px;" (keyup)="auto_grow($event)" formControlName="learningGoalsObj" (focus)="learningGoalsObjFldInFocus=true" (blur)="learningGoalsObjFldInFocus=false"></textarea>
                </div>
              </div>
              <div class="sh-grid-1">
                <div class="mat-div" [class.is-active]="pLearningExpFldInFocus==true" [class.is-completed]="pLearningExpFocussed() || pLearningExpFldInFocus==true">
                  <label class="mat-label"><strong>Past Learning Experience</strong></label>
                  <textarea class="mat-input" style="max-height: 100px;" (keyup)="auto_grow($event)" formControlName="pLearningExp" (focus)="pLearningExpFldInFocus=true" (blur)="pLearningExpFldInFocus=false"></textarea>
                </div>
              </div>
              <div class="sh-grid-1">
                <div class="mat-div" [class.is-active]="pSuccessMetricsFldInFocus==true" [class.is-completed]="pSuccessMetricsFocussed() || pSuccessMetricsFldInFocus==true">
                  <label class="mat-label"><strong>Personal Success Metrics</strong></label>
                  <textarea class="mat-input" style="max-height: 100px;" (keyup)="auto_grow($event)" formControlName="pSuccessMetrics" (focus)="pSuccessMetricsFldInFocus=true" (blur)="pSuccessMetricsFldInFocus=false"></textarea>
                </div>
              </div>
              <div class="sh-grid-1">
                <div class="mat-div" [class.is-active]="pLearningHabFldInFocus==true" [class.is-completed]="pLearningHabFocussed() || pLearningHabFldInFocus==true">
                  <label class="mat-label"><strong>Personal Learning Habits</strong></label>
                  <textarea class="mat-input" formControlName="pLearningHab" (focus)="pLearningHabFldInFocus=true" (blur)="pLearningHabFldInFocus=false"></textarea>
                </div>
              </div>
              <div class="sh-grid-1">
                <div class="mat-div" [class.is-active]="suggestionsFldInFocus==true" [class.is-completed]="suggestionsFocussed() || suggestionsFldInFocus==true">
                  <label class="mat-label"><strong>Any suggestions for your teacher</strong></label>
                  <textarea class="mat-input" style="max-height: 100px;" (keyup)="auto_grow($event)" formControlName="suggestions" (focus)="suggestionsFldInFocus=true" (blur)="suggestionsFldInFocus=false"></textarea>
                </div>
              </div>
              
            </div>
          </form>
        </div>
      </div>
      

    </div>
    <div class="ui_modal_btns">
      <a class="ui_btn ui_btn_primary" href="javascript:void(0)" (click)="submit()" >Submit</a>
      <a class="ui_btn ui_btn_basic" href="javascript:void(0)" (click)="closeIcon()">Cancel</a>

    </div>
  </div>
</div>
